const styles = theme => ({
})

export default styles
